import { Type } from '@angular/core';
import {
  CommissioningAddVentilationModalComponent,
  CommissioningAddRoomModalComponent,
  CommissioningAssignChannelModalComponent,
  CommissioningAssignHeatingCircuitModalComponent,
  CommissioningAssignmentLoaderModalComponent,
  CommissioningCodeModalComponent,
  CommissioningDeviceTypeModalComponent,
  CommissioningFinalResultModalComponent,
  CommissioningPairingModalComponent,
  CommissioningPairingResultModalComponent,
  CommissioningReminderModalComponent,
} from './';

export type CommisioningComponent =
  | CommissioningDeviceTypeModalComponent
  | CommissioningCodeModalComponent
  | CommissioningReminderModalComponent
  | CommissioningPairingModalComponent
  | CommissioningPairingResultModalComponent
  | CommissioningAssignHeatingCircuitModalComponent
  | CommissioningAddVentilationModalComponent
  | CommissioningAddRoomModalComponent
  | CommissioningAssignChannelModalComponent
  | CommissioningAssignmentLoaderModalComponent
  | CommissioningFinalResultModalComponent;

export interface CommissioningStrategy {
  steps: Type<CommisioningComponent>[];
}

export const initialStrategy: CommissioningStrategy = {
  steps: [CommissioningDeviceTypeModalComponent],
};

export const eTRVStrategy: CommissioningStrategy = {
  steps: [
    CommissioningDeviceTypeModalComponent,
    CommissioningCodeModalComponent,
    CommissioningReminderModalComponent,
    CommissioningPairingModalComponent,
    CommissioningPairingResultModalComponent,
    CommissioningAssignHeatingCircuitModalComponent,
    CommissioningAssignmentLoaderModalComponent,
    CommissioningAddRoomModalComponent,
    CommissioningAssignmentLoaderModalComponent,
    CommissioningFinalResultModalComponent,
  ],
};

export const eTRVStandaloneStrategy: CommissioningStrategy = {
  steps: [
    CommissioningDeviceTypeModalComponent,
    CommissioningCodeModalComponent,
    CommissioningReminderModalComponent,
    CommissioningPairingModalComponent,
    CommissioningPairingResultModalComponent,
    CommissioningAssignmentLoaderModalComponent,
    CommissioningAddRoomModalComponent,
    CommissioningAssignmentLoaderModalComponent,
    CommissioningFinalResultModalComponent,
  ],
};

export const csStrategy: CommissioningStrategy = {
  steps: [
    CommissioningDeviceTypeModalComponent,
    CommissioningCodeModalComponent,
    CommissioningReminderModalComponent,
    CommissioningPairingModalComponent,
    CommissioningPairingResultModalComponent,
    CommissioningAddRoomModalComponent,
    CommissioningAssignmentLoaderModalComponent,
    CommissioningFinalResultModalComponent,
  ],
};

export const csRepeaterStrategy: CommissioningStrategy = {
  steps: [
    CommissioningDeviceTypeModalComponent,
    CommissioningCodeModalComponent,
    CommissioningReminderModalComponent,
    CommissioningPairingModalComponent,
    CommissioningPairingResultModalComponent,
    CommissioningFinalResultModalComponent,
  ],
};

export const repeaterStrategy: CommissioningStrategy = {
  steps: [
    CommissioningDeviceTypeModalComponent,
    CommissioningCodeModalComponent,
    CommissioningReminderModalComponent,
    CommissioningPairingModalComponent,
    CommissioningPairingResultModalComponent,
    CommissioningFinalResultModalComponent,
  ],
};

export const fhtStrategy: CommissioningStrategy = {
  steps: [
    CommissioningDeviceTypeModalComponent,
    CommissioningCodeModalComponent,
    CommissioningReminderModalComponent,
    CommissioningPairingModalComponent,
    CommissioningPairingResultModalComponent,
    CommissioningAssignChannelModalComponent,
    CommissioningAssignHeatingCircuitModalComponent,
    CommissioningAssignmentLoaderModalComponent,
    CommissioningFinalResultModalComponent,
  ],
};

export const fhtStandaloneStrategy: CommissioningStrategy = {
  steps: [
    CommissioningDeviceTypeModalComponent,
    CommissioningCodeModalComponent,
    CommissioningReminderModalComponent,
    CommissioningPairingModalComponent,
    CommissioningPairingResultModalComponent,
    CommissioningAssignChannelModalComponent,
    CommissioningAssignmentLoaderModalComponent,
    CommissioningFinalResultModalComponent,
  ],
};

export const airQualitySensorStrategy: CommissioningStrategy = {
  steps: [
    CommissioningDeviceTypeModalComponent,
    CommissioningCodeModalComponent,
    CommissioningReminderModalComponent,
    CommissioningPairingModalComponent,
    CommissioningPairingResultModalComponent,
    CommissioningAddRoomModalComponent,
    CommissioningAssignmentLoaderModalComponent,
    CommissioningFinalResultModalComponent,
  ],
};

export const vicareThermostatCsStrategyStrategy: CommissioningStrategy = {
  steps: [
    CommissioningDeviceTypeModalComponent,
    CommissioningCodeModalComponent,
    CommissioningReminderModalComponent,
    CommissioningPairingModalComponent,
    CommissioningPairingResultModalComponent,
  ],
};

export const vicareThermostatCsRepeaterStrategy: CommissioningStrategy = {
  steps: [
    CommissioningDeviceTypeModalComponent,
    CommissioningCodeModalComponent,
    CommissioningReminderModalComponent,
    CommissioningPairingModalComponent,
    CommissioningPairingResultModalComponent,
  ],
};

export const vicareThermostatRepeaterStrategy: CommissioningStrategy = {
  steps: [
    CommissioningDeviceTypeModalComponent,
    CommissioningCodeModalComponent,
    CommissioningReminderModalComponent,
    CommissioningPairingModalComponent,
    CommissioningPairingResultModalComponent,
  ],
};

export const vicareThermostatVitotrol_100E: CommissioningStrategy = {
  steps: [
    CommissioningDeviceTypeModalComponent,
    CommissioningCodeModalComponent,
    CommissioningReminderModalComponent,
    CommissioningPairingModalComponent,
    CommissioningPairingResultModalComponent,
  ],
};

export const vicareThermostatVitotrol_300E: CommissioningStrategy = {
  steps: [
    CommissioningDeviceTypeModalComponent,
    CommissioningCodeModalComponent,
    CommissioningReminderModalComponent,
    CommissioningPairingModalComponent,
    CommissioningPairingResultModalComponent,
    CommissioningAssignHeatingCircuitModalComponent,
    CommissioningAddVentilationModalComponent,
    CommissioningAssignmentLoaderModalComponent,
    CommissioningFinalResultModalComponent,
  ],
};

export const vicareThermostatVitotrol_300E_System: CommissioningStrategy = {
  steps: [
    CommissioningDeviceTypeModalComponent,
    CommissioningCodeModalComponent,
    CommissioningReminderModalComponent,
    CommissioningPairingModalComponent,
    CommissioningPairingResultModalComponent,
    CommissioningAssignHeatingCircuitModalComponent,
    CommissioningAddVentilationModalComponent,
    CommissioningAssignmentLoaderModalComponent,
    CommissioningFinalResultModalComponent,
  ],
};
